import { normalizeAuthEmail } from './authEmailOtp.js';
import { normalizeAuthCaptchaToken } from './authTurnstile.js';

const AUTH_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const AUTH_EMAIL_CONFIRMATION_RESEND_ENDPOINT =
  '/api/auth/resend-confirmation';

export class AuthEmailConfirmationResendError extends Error {
  constructor(message, code = 'email_confirmation_resend_failed', status = 500) {
    super(message);
    this.name = 'AuthEmailConfirmationResendError';
    this.code = code;
    this.status = status;
  }
}

export const buildAuthEmailConfirmationResendPayload = (input = {}) => {
  const email = normalizeAuthEmail(input.email);
  const captchaToken = normalizeAuthCaptchaToken(input.captchaToken);

  if (!email || email.length > 320 || !AUTH_EMAIL_PATTERN.test(email)) {
    throw new AuthEmailConfirmationResendError(
      'Indirizzo email non valido.',
      'invalid_email',
      400,
    );
  }

  return {
    email,
    ...(captchaToken ? { captchaToken } : {}),
  };
};

const parseResponseBody = async (response) => {
  try {
    return await response.json();
  } catch {
    return {};
  }
};

export const requestAuthEmailConfirmationResend = async (
  input,
  { fetchImpl = globalThis.fetch } = {},
) => {
  const payload = buildAuthEmailConfirmationResendPayload(input);

  if (typeof fetchImpl !== 'function') {
    throw new AuthEmailConfirmationResendError(
      'Servizio di reinvio non disponibile.',
      'email_confirmation_resend_unavailable',
      503,
    );
  }

  const response = await fetchImpl(AUTH_EMAIL_CONFIRMATION_RESEND_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const body = await parseResponseBody(response);

  if (!response.ok) {
    throw new AuthEmailConfirmationResendError(
      body?.message || 'Impossibile reinviare l’email di conferma.',
      body?.error || 'email_confirmation_resend_failed',
      response.status,
    );
  }

  return { accepted: body?.accepted === true };
};
